import trackClicks, { parsePayload } from './data_layer';

// Step 2 of the memberships_progress funnel: the member picks a membership and
// is handed off to Flow. The payload is rendered onto the card, so every choose
// control it holds is tracked; only the plan is decided in the browser, by the
// card's annual/monthly toggle.
const CHOOSE = '.membership-type__choose, .membership-type__modal-choose';
const CARD = '.membership-type';

function annualSelected(card) {
  const toggle = card.querySelector('.membership-type__toggle');
  return Boolean(toggle && toggle.checked);
}

function selectedPlan(card, item) {
  if (!annualSelected(card)) return item;
  return { ...item, ...parsePayload(card.dataset.dataLayerAlternate) };
}

function buildPayload(link) {
  const card = link.closest(CARD);
  const payload = card && parsePayload(card.dataset.dataLayer);
  if (!payload || !payload.event) return null;

  const ecommerce = payload.ecommerce || {};
  const items = (ecommerce.items || []).map(item => selectedPlan(card, item));
  return { ...payload, ecommerce: { ...ecommerce, items } };
}

export default function membershipsTracking() {
  trackClicks(CHOOSE, buildPayload);
}
